<template>
  <div>
    <!-- FILTER START -->
    <div class="row align-items-center justify-content-end">
      <div class="d-flex col-md-4 relative">
        <input type="text" class="form-control" v-model="filter.search" placeholder="Search" />
        <button type="button" style="
            background: transparent;
            outline: none;
            border: none;
            position: absolute;
            right: 1rem;
            top: 0.375rem;
          " @click="fetchData">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M9.89279 5.44689C9.89279 7.8907 7.91169 9.8718 5.46788 9.8718C3.02407 9.8718 1.04297 7.8907 1.04297 5.44689C1.04297 3.00307 3.02407 1.02197 5.46788 1.02197C7.91169 1.02197 9.89279 3.00307 9.89279 5.44689Z"
              stroke="#9D9D9D" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M10.9998 10.9778L8.59375 8.57178" stroke="#9D9D9D" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </button>
      </div>
      <button v-if="isSuperAdmin" type="button" class="btn btn-primary" style="height: 32px" @click="modal.new = true">
        New User
      </button>
    </div>

    <!-- FILTER END -->

    <div class="bg-white shadow box-content mt-4">
      <div class="mt-3 scan-history-table-wrapper">
        <!-- Loading State -->
        <div v-if="tableLoading" class="text-center mt-3 mb-3">
          <h4>Loading...</h4>
        </div>

        <!-- Table -->
        <div v-else style="overflow-x: auto; overflow-y: hidden">
          <table class="table scan-history-table" style="margin: 0">
            <thead>
              <tr>
                <th>Username</th>
                <th>Type</th>
                <th>Product</th>
                <th>Status</th>
                <th>Last Login</th>
                <th v-if="isSuperAdmin">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in tableData" :key="index">
                <td>{{ row.username || 'N/A' }}</td>
                <td>{{ row.roles || 'N/A' }}</td>
                <td>{{ row.product_category || 'N/A' }}</td>
                <td :style="getStatusStyle(row.status)">{{ row.status || 'N/A' }}</td>
                <td>{{ row.last_login || 'N/A' }}</td>
                <td v-if="isSuperAdmin" style="display: flex; align-items: center; gap: 8px;">
                  <button type="button" @click="editUser(row)"
                    style="background: transparent; border: none; padding: 0; cursor: pointer;" title="Edit">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect x="0.75" y="0.75" width="22.5" height="22.5" rx="4.25" stroke="#267CE5"
                        stroke-width="1.5" />
                      <path
                        d="M8.11755 8.8252H7.4117C7.03729 8.8252 6.67822 8.97393 6.41348 9.23867C6.14873 9.50342 6 9.86249 6 10.2369V16.5896C6 16.964 6.14873 17.323 6.41348 17.5878C6.67822 17.8525 7.03729 18.0013 7.4117 18.0013H13.7644C14.1388 18.0013 14.4978 17.8525 14.7626 17.5878C15.0273 17.323 15.1761 16.964 15.1761 16.5896V15.8837"
                        stroke="#267CE5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      <path
                        d="M14.4703 7.41178L16.5878 9.52933M17.5654 8.53055C17.8434 8.25255 17.9996 7.87551 17.9996 7.48236C17.9996 7.08921 17.8434 6.71217 17.5654 6.43417C17.2874 6.15618 16.9104 6 16.5172 6C16.1241 6 15.747 6.15618 15.469 6.43417L9.5293 12.3527V14.4703H11.6468L17.5654 8.53055Z"
                        stroke="#267CE5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </button>
                  <button type="button" @click="deleteUser(row.id)"
                    style="background: transparent; border: none; padding: 0; cursor: pointer;" title="Delete">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect x="0.75" y="0.75" width="22.5" height="22.5" rx="4.25" stroke="#CD2E2C"
                        stroke-width="1.5" />
                      <path
                        d="M17.3333 6.5C17.5101 6.5 17.6797 6.57024 17.8047 6.69526C17.9298 6.82029 18 6.98986 18 7.16667C18 7.34348 17.9298 7.51305 17.8047 7.63807C17.6797 7.7631 17.5101 7.83333 17.3333 7.83333H16.6667L16.6647 7.88067L16.0427 16.5947C16.0187 16.9311 15.8682 17.2459 15.6214 17.4757C15.3746 17.7056 15.0499 17.8333 14.7127 17.8333H9.28667C8.94943 17.8333 8.62471 17.7056 8.37792 17.4757C8.13114 17.2459 7.98061 16.9311 7.95667 16.5947L7.33467 7.88133L7.33333 7.83333H6.66667C6.48986 7.83333 6.32029 7.7631 6.19526 7.63807C6.07024 7.51305 6 7.34348 6 7.16667C6 6.98986 6.07024 6.82029 6.19526 6.69526C6.32029 6.57024 6.48986 6.5 6.66667 6.5H17.3333ZM15.3313 7.83333H8.66867L9.28733 16.5H14.7127L15.3313 7.83333ZM13.3333 4.5C13.5101 4.5 13.6797 4.57024 13.8047 4.69526C13.9298 4.82029 14 4.98986 14 5.16667C14 5.34348 13.9298 5.51305 13.8047 5.63807C13.6797 5.7631 13.5101 5.83333 13.3333 5.83333H10.6667C10.4899 5.83333 10.3203 5.7631 10.1953 5.63807C10.0702 5.51305 10 5.34348 10 5.16667C10 4.98986 10.0702 4.82029 10.1953 4.69526C10.3203 4.57024 10.4899 4.5 10.6667 4.5H13.3333Z"
                        fill="#CD2E2C" />
                    </svg>
                  </button>
                </td>
              </tr>
              <tr v-if="!tableLoading && tableData.length === 0">
                <td :colspan="isSuperAdmin ? 6 : 5" class="text-center">No data available</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <div class="row mt-3" v-if="!tableLoading && (tableData.length > 0 || maxPage > 0)">
          <div class="col-12 d-flex align-items-center justify-content-between flex-wrap">
            <div class="d-flex align-items-center">
              <label for="view-items-per-page"
                style="margin-right: 8px; margin-bottom: 0; color: #a3a4a6; font-size: 14px;">View</label>
              <select id="view-items-per-page" v-model="limitPerPage" @change="onLimitChange"
                class="form-control form-control-sm" style="width: auto; display: inline-block; padding: 4px 8px;">
                <option :value="10">10</option>
                <option :value="25">25</option>
                <option :value="50">50</option>
                <option :value="100">100</option>
              </select>
              <span style="margin-left: 8px; color: #a3a4a6; font-size: 14px;">items per page</span>
            </div>
            <div class="d-flex align-items-center flex-wrap">
              <p class="mt-2 mb-2" style="color: #a3a4a6; margin-right: 20px; margin-bottom: 0;">
                Showing {{ (currentPage - 1) * limitPerPage + 1 }}-{{ currentPage * limitPerPage < total ? currentPage *
                  limitPerPage : total }} of {{ total > 0 ? total : '?' }} Items
              </p>
              <nav class="pagination-minimal">
                <ul class="pagination" style="margin: 0; flex-wrap: wrap;">
                  <li class="page-item" :class="{ disabled: currentPage <= 1 }"
                    @click.stop.prevent="changePage('prev')">
                    <a class="page-link" href="javascript:void(0)">&lsaquo;</a>
                  </li>
                  <li class="page-item" :class="{ disabled: currentPage >= maxPage && !hasMoreData }"
                    @click.stop.prevent="changePage('next')">
                    <a class="page-link" href="javascript:void(0)">&rsaquo;</a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div v-if="this.user.super_admin === 1" class="col-lg-2"> -->
    <cu-user-management-super-admin v-if="modal.new || modal.edit" :data="modal.edit ? modal.editData : null"
      api_new="/api/admin/user" api_edit="/api/admin/user/" form_type="User Dashboard" :is_company_exist="false"
      @refreshData="refreshData" @closeModal="
        modal.new = false;
      modal.edit = false;
      "></cu-user-management-super-admin>
  </div>
  <!-- </div> -->
</template>

<script>
import cuUserManagementSuperAdmin from "./children/CUUserManagementSuperAdmin.vue";
import "@/assets/mixin/methods.js";
import qs from "qs";

export default {
  metaInfo: {
    title: "Dashboard User Management",
  },
  data() {
    return {
      user: this.$store.getters.currentUser,
      modal: {
        new: false,
        edit: false,
        editData: false,
      },
      filter: {
        search: "",
      },
      // Table data
      tableData: [],
      tableLoading: false,
      currentPage: 1,
      maxPage: 1,
      total: 0,
      limitPerPage: 10,
      // Debounce timer
      fetchDataTimer: null,
    };
  },
  components: {
    cuUserManagementSuperAdmin,
  },
  computed: {
    hasMoreData() {
      // If we got a full page of data, there's likely more
      return this.tableData.length === this.limitPerPage;
    },
    isSuperAdmin() {
      return this.user && this.user.super_admin === 1;
    },
  },
  mounted() {
    this.fetchData();
  },
  beforeDestroy() {
    if (this.fetchDataTimer) {
      clearTimeout(this.fetchDataTimer);
    }
  },
  watch: {
    "filter.search": function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.currentPage = 1; // Reset to first page
        this.fetchData();
      }
    },
  },
  methods: {
    async fetchData() {
      // Clear existing timer to debounce rapid calls
      if (this.fetchDataTimer) {
        clearTimeout(this.fetchDataTimer);
      }

      this.fetchDataTimer = setTimeout(() => {
        this.performFetchData();
      }, 300); // 300ms debounce
    },
    async performFetchData() {
      this.tableLoading = true;

      try {
        const token = this.user.token;
        const headers = {
          Authorization: `Bearer ${token}`,
        };

        // Get total count first
        const totalResp = await this.$httpSSO.get("/api/admin/user?page=1&limit=150", { headers });
        const total = totalResp.data.data.length;

        // Build query params
        let queryParams = {
          pagination: true,
          limit: this.limitPerPage,
          page: this.currentPage,
          order: "DESC",
          by: "created_at",
        };

        // Add search filter
        if (this.filter.search && this.filter.search.trim()) {
          queryParams.search = this.filter.search.trim();
        }

        const url = `/api/admin/user?${qs.stringify(queryParams, {
          skipNulls: true,
          arrayFormat: "comma",
        })}`;

        const resp = await this.$httpSSO.get(url, { headers });

        let data = resp.data.data || [];

        // Process data - transform status and product_category
        if (Array.isArray(data)) {
          data = data.map((item) => ({
            ...item,
            status: item.status === 1 ? "Active" : "Inactive",
            product_category: Array.isArray(item.product_category)
              ? item.product_category.join(", ")
              : item.product_category || "N/A",
            last_login: item.last_login ? formatToJakartaTime(item.last_login) : '-'
          }));
        }

        // Get pagination meta
        const meta = resp.data.meta || resp.data.pagination || resp.data || {};

        const currentPage = meta.currentPage || meta.current_page || meta.page || this.currentPage || 1;
        let lastPage = meta.lastPage || meta.last_page || meta.totalPages || meta.total_pages || meta.maxPage || 0;

        // If total is 0 but we have data, we need to estimate
        if (total === 0) {
          if (data.length === this.limitPerPage) {
            lastPage = this.currentPage + 1;
          } else if (data.length > 0) {
            lastPage = this.currentPage;
          } else {
            lastPage = 1;
          }
        } else if (total > 0) {
          if (!lastPage || lastPage === 0) {
            lastPage = Math.ceil(total / this.limitPerPage);
          }
        }

        lastPage = Math.max(1, lastPage);

        if (data.length === this.limitPerPage && this.currentPage >= lastPage) {
          lastPage = this.currentPage + 1;
        }

        // Update state
        this.$set(this, 'tableData', data);
        this.$set(this, 'currentPage', Number.parseInt(currentPage));
        this.$set(this, 'maxPage', Number.parseInt(lastPage));
        this.$set(this, 'total', Number.parseInt(total));
      } catch (err) {
        console.log('Error fetching user data:', err);
        this.$set(this, 'tableData', []);
        this.$set(this, 'currentPage', 1);
        this.$set(this, 'maxPage', 1);
        this.$set(this, 'total', 0);
      } finally {
        this.tableLoading = false;
      }
    },
    onLimitChange() {
      this.$set(this, 'currentPage', 1);
      this.fetchData();
    },
    changePage(opt) {
      if (this.tableLoading) {
        return;
      }

      let newPage = this.currentPage;

      if (opt === 'prev') {
        newPage = Math.max(1, this.currentPage - 1);
      } else if (opt === 'next') {
        if (this.hasMoreData || this.currentPage < this.maxPage) {
          newPage = this.currentPage + 1;
        } else {
          return;
        }
      }

      if (newPage !== this.currentPage && newPage >= 1) {
        this.$set(this, 'currentPage', newPage);
        this.fetchData();
      }
    },
    getStatusStyle(status) {
      const styles = {
        Active: "color:#34CE4C; font-weight:bold",
        Inactive: "color:red; font-weight:bold",
      };
      return styles[status] || "";
    },
    editUser(user) {
      this.modal.editData = user;
      this.modal.edit = true;
    },
    deleteUser(userId) {
      const token = this.user.token;
      const headers = {
        Authorization: `Bearer ${token}`,
      };

      this.$swal
        .fire({
          title: "Are you sure?",
          text: "Deleting a user is permanent and cannot be undone — proceed with caution",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#D33",
          cancelButtonColor: "#1B698E",
          confirmButtonText: "Delete",
          customClass: "custom",
          didOpen: () => {
            const confirmButton = document.querySelector('.swal2-confirm');
            const cancelButton = document.querySelector('.swal2-cancel');
            if (confirmButton) {
              confirmButton.style.marginLeft = '20px';
              confirmButton.style.padding = '12px 45px';
            }

            if (cancelButton) {
              confirmButton.style.marginRight = '20px';
              cancelButton.style.padding = '12px 45px';
            }
          }
        })
        .then((result) => {
          if (result.value) {
            this.$httpSSO
              .delete("/api/admin/user/" + userId, { headers })
              .then((resp) => {
                this.$swal.fire({
                  title: "Success!",
                  icon: "success",
                  type: "success",
                  text: `User has been successfully deleted`,
                });
                this.fetchData(); // Refresh table after deletion
              })
              .catch((error) => {
                console.log(
                  "%cerror DashboardUserUM.vue line:78 ",
                  "color: red; display: block; width: 100%;",
                  error
                );
                this.$swal.fire({
                  title: "Error!",
                  icon: "error",
                  type: "error",
                  text: (error.response && error.response.data && error.response.data.message) || "An error occurred",
                });
              });
          }
        });
    },
    refreshData() {
      this.fetchData();
    },
  },
};
</script>

<style scoped>
.box-content {
  padding: 20px;
  border-radius: 10px;
}

/* Scan History Table Styles */
.scan-history-table-wrapper .scan-history-table {
  border-collapse: separate;
  border-spacing: 0;
  border: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody tr {
  background-color: #FFFFFF !important;
  border-top: none !important;
  border-bottom: none !important;
}

.scan-history-table-wrapper .scan-history-table.table-striped tbody tr {
  background-color: #FFFFFF !important;
  border-top: none !important;
  border-bottom: none !important;
}

.scan-history-table-wrapper .scan-history-table.table-striped tbody tr:nth-of-type(odd) {
  background-color: #FFFFFF !important;
}

.scan-history-table-wrapper .scan-history-table thead th {
  color: #9D9D9D;
  text-align: left;
  vertical-align: middle;
  border-bottom: 1px solid #dee2e6;
  border-top: none !important;
}

.scan-history-table-wrapper .scan-history-table thead th:first-child {
  border-left: none !important;
}

.scan-history-table-wrapper .scan-history-table thead th:last-child {
  border-right: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody td {
  color: #4B4B4B;
  text-align: left;
  vertical-align: middle;
  background-color: #FFFFFF !important;
  border-top: none !important;
  border-bottom: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody td:first-child {
  border-left: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody td:last-child {
  border-right: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody tr:first-child td {
  border-top: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody tr:last-child td {
  border-bottom: none !important;
}

/* Pagination Styles - Minimalist */
.scan-history-table-wrapper .pagination-minimal .pagination {
  margin-bottom: 0;
}

.scan-history-table-wrapper .pagination-minimal .page-item {
  margin: 0 2px;
}

.scan-history-table-wrapper .pagination-minimal .page-item .page-link {
  background: transparent !important;
  border: none !important;
  color: #4B4B4B;
  padding: 4px 8px;
  cursor: pointer;
  user-select: none;
  font-size: 14px;
}

.scan-history-table-wrapper .pagination-minimal .page-item:not(.disabled):hover .page-link {
  background: transparent !important;
  color: #007bff;
}

.scan-history-table-wrapper .pagination-minimal .page-item.disabled .page-link {
  cursor: not-allowed;
  pointer-events: none;
  opacity: 0.4;
  color: #9D9D9D !important;
}

.scan-history-table-wrapper .pagination-minimal .page-item.active .page-link {
  background: transparent !important;
  border: none !important;
  color: #007bff !important;
  font-weight: 600;
}

.scan-history-table-wrapper .pagination-minimal .page-item.active .page-link:hover {
  background: transparent !important;
  color: #007bff !important;
}
</style>
<style>
.custom .swal2-styled.swal2-cancel {
  order: -1;
}
</style>